import { useState } from "react";
import { CHANGELOG } from "../data/changelog";

const STORAGE_KEY = "lineup:whatsNewState";

// Whether the What's New card is expanded (full bullet list) or collapsed
// (one small line, tap to reopen). Stored per changelog entry id, not as a
// bare state, so a new release always starts expanded even if the viewer
// had collapsed a previous one. Backed by localStorage rather than a DB
// column: it's a per-device UI preference, not something that needs to
// sync across a manager's devices. In the Capacitor app this is the
// WebView's own localStorage, which persists across launches the same as
// in a browser.
export function useWhatsNewState() {
  const latest = CHANGELOG[0] || null;

  const [state, setState] = useState(() => {
    if (!latest) return "expanded";
    try {
      const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      if (stored && stored.id === latest.id) return stored.state;
    } catch {
      // Storage can throw in a private tab or with site data blocked, or
      // hold malformed JSON from an older build. Falling back to expanded
      // just means the card shows again, the safer of the two wrong answers.
    }
    return "expanded";
  });

  const persist = (next) => {
    setState(next);
    if (!latest) return;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ id: latest.id, state: next }));
    } catch {
      // Nothing to fall back to here: the preference just resets next visit.
    }
  };

  return {
    latest,
    state,
    collapse: () => persist("collapsed"),
    expand: () => persist("expanded"),
  };
}
